/**
 * Format display name from firstName, middleName, lastName.
 * Falls back to userId or placeholder when no name parts are present.
 */
export function formatDisplayName(
  user: {
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    userId?: string | null;
  } | null | undefined,
  placeholder = '—'
): string {
  if (!user) return placeholder;
  const parts = [
    user.firstName?.trim(),
    user.middleName?.trim(),
    user.lastName?.trim(),
  ].filter(Boolean);
  if (parts.length > 0) return parts.join(' ');
  return user.userId?.trim() || placeholder;
}

/**
 * Get first name or initial for greeting/avatar (e.g. "John" or "J").
 */
export function getDisplayInitial(
  user: {
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    userId?: string | null;
  } | null | undefined,
  fallback = 'U'
): string {
  if (!user) return fallback;
  const first = user.firstName?.trim();
  if (first) return first[0]?.toUpperCase() || fallback;
  return user.userId?.[0]?.toUpperCase() || fallback;
}
